import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { AddOnCardLayoutUI } from '../../../components/available-add-ons-list/AddOnCardLayoutUI';
import { createAddOnCardTrackingData } from '../../utils/trackingData';
import { isAvailableCurrencyCode } from '../../utils/typeguards';
import { AddOnAlert } from './AddOnAlert';
import { AddOnCTA } from './AddOnCTA';
import { jsx as _jsx } from "react/jsx-runtime";
export function AddOnCard({
  productApiName,
  titleText,
  descriptionText,
  productDetails,
  purchaseMotion,
  purchaseOption,
  ownedQuantity,
  includedQuantity,
  isHubSpotCredits,
  currencyCode
}) {
  const price = purchaseOption && purchaseOption.monthlyPrice ? Number(purchaseOption.monthlyPrice) : null;
  const trackingData = createAddOnCardTrackingData(productApiName);
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `add-on-card-${productApiName}`,
    "data-selenium-id": `add-on-card-${productApiName}`,
    title: titleText,
    description: descriptionText,
    pricing: price ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonth",
      options: {
        price: /*#__PURE__*/_jsx(PriceDisplay, {
          price: price,
          currencyCode: isAvailableCurrencyCode(currencyCode) ? currencyCode : 'USD',
          dataSelenium: `${productApiName}-price-per-month`
        })
      }
    }) : null,
    alert: /*#__PURE__*/_jsx(AddOnAlert, {
      productApiName: productApiName,
      ownedQuantity: ownedQuantity,
      includedQuantity: includedQuantity,
      isHubSpotCredits: isHubSpotCredits
    }),
    cta: /*#__PURE__*/_jsx(AddOnCTA, {
      productApiName: productApiName,
      trackingData: trackingData,
      productDetails: productDetails,
      ownedQuantity: ownedQuantity,
      purchaseMotion: purchaseMotion,
      purchaseOption: purchaseOption,
      isHubSpotCredits: isHubSpotCredits
    })
  });
}